import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarCategoriaEmpresa, setModalDeletarCategoriaEmpresa } from "../redux/slices/categoriaEmpresa/categoriaEmpresaSlice";

export const cadastrarCategoriaEmpresa = createAsyncThunk("/CategoriaEmpresa/CadastrarCategoriaEmpresa", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/CategoriaEmpresa/CadastrarCategoriaEmpresa/", payload.value);
    toastSucess("A categoria empresa foi cadastrada com sucesso");
    dispatch(setModalCadastrarCategoriaEmpresa(false));
    dispatch(setLoading(false));

    dispatch(buscarCategoriaEmpresa());
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarCategoriaEmpresa = createAsyncThunk("/CategoriaEmpresa/BuscarCategoriaEmpresa", async () => {
  try {
    const data = await api.get("/CategoriaEmpresa/BuscarCategoriaEmpresa/");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarCategoriaEmpresa = createAsyncThunk("/CategoriaEmpresa/AtualizarCategoriaEmpresa", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/CategoriaEmpresa/AtualizarCategoriaEmpresa/", payload.value);
    toastSucess("A categoria empresa foi atualizada com sucesso");
    dispatch(setModalCadastrarCategoriaEmpresa(false));
    dispatch(setLoading(false));

    dispatch(buscarCategoriaEmpresa());
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarCategoriaEmpresa = createAsyncThunk("/CategoriaEmpresa/DeletarCategoriaEmpresa", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/CategoriaEmpresa/DeletarCategoriaEmpresa/", { params: { id: payload.value } });
    toastSucess("A categoria empresa foi removida com sucesso");
    dispatch(setModalDeletarCategoriaEmpresa(false));
    dispatch(setLoading(false));

    dispatch(buscarCategoriaEmpresa());
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
